export default __webpack_public_path__ + "static/media/Finance-min.157cedbc.png";